import { FunctionComponent } from 'react'
import {
  CaretDownIcon,
  InfoIcon,
  ArrowsClockwiseIcon,
  UserIcon,
  UserCircleIcon,
  UsersThreeIcon,
  LockIcon,
  SignOutIcon
} from '@phosphor-icons/react'
import { AppAvatar, AppSwitch, AppButton, AppPopover, AppBadge } from '@/shared/ui'

export type UserProfileProps = {
  isVisible?: boolean
  onClick: () => void
  firstName?: string
  lastName?: string
  email?: string
  client?: string
  role?: string
  isAvailable?: boolean
  photoUrl?: string
  isEnterprise?: boolean
  validActiveUser?: boolean
  userGroup?: string
  badgeColor?: string
  translate: (arg0: string) => string
  onAvailableSwitchChange?: () => void
  onRoleClick?: () => void
  onPersonalInfoClick?: () => void
  onLogOutClick?: () => void
  onChangeClientClick?: () => void
  onChangePasswordClick?: () => void
  onGroupClick?: () => void
  onGroupStoresClick?: () => void
}

export const UserProfileInfo: FunctionComponent<UserProfileProps> = ({
  isVisible = false,
  onClick = () => {},
  firstName = '',
  lastName = '',
  email = '',
  client = '',
  role = '',
  isAvailable = false,
  photoUrl = '',
  isEnterprise = true,
  validActiveUser = true,
  userGroup = '',
  badgeColor = 'red',
  translate = (arg0: string) => '',
  onAvailableSwitchChange = () => {},
  onRoleClick = () => {}, //Open role information modal
  onPersonalInfoClick = () => {},
  onLogOutClick = () => {},
  onChangeClientClick = () => {},
  onChangePasswordClick = () => {},
  onGroupClick = () => {},
  onGroupStoresClick = () => {}
}: UserProfileProps): JSX.Element => {
  return (
    <AppPopover
      placement='bottomRight'
      open={isVisible}
      content={
        <div>
          <div className='user-profile-header'>
            <img className='user-profile-image-avatar' src={photoUrl || '/default-user.png'} alt='userPic' />
            <p className='user-name'>
              {firstName} {lastName}
            </p>
            <p className='user-client'>{client}</p>
            <AppButton className='user-role' variant='link' onClick={onRoleClick}>
              {role}
              <InfoIcon />
            </AppButton>
          </div>
          {validActiveUser ? (
            <div className='user-profile-common-div'>
              <UserCircleIcon className='user-profile-popover-icon' />
              <p className='user-profile-div-text-availability'>{translate('user-profile.availability')}</p>
              <div className='user-profile-switch'>
                <AppSwitch checked={isAvailable} onChange={onAvailableSwitchChange} />
              </div>
            </div>
          ) : null}
          {isEnterprise ? (
            <div className='user-profile-common-div'>
              <ArrowsClockwiseIcon className='user-profile-popover-icon' />
              <p className='user-profile-div-text' onClick={onChangeClientClick}>
                {translate('user-profile.change-client')}
              </p>
            </div>
          ) : null}
          {userGroup ? (
            <div className='user-profile-common-div'>
              <UsersThreeIcon className='user-profile-popover-icon' />
              <p className='user-profile-div-text' onClick={onGroupClick}>
                {'Alertas asignadas al grupo'}
              </p>
            </div>
          ) : null}
          {userGroup ? (
            <div className='user-profile-common-div'>
              <UsersThreeIcon className='user-profile-popover-icon' />
              <p className='user-profile-div-text' onClick={onGroupStoresClick}>
                {'Tiendas asignadas al grupo'}
              </p>
            </div>
          ) : null}
          <div className='user-profile-common-div'>
            <UserIcon className='user-profile-popover-icon' />
            <p className='user-profile-div-text' onClick={onPersonalInfoClick}>
              {translate('user-profile.personal-info')}
            </p>
          </div>
          <div className='user-profile-common-div'>
            <LockIcon className='user-profile-popover-icon' />
            <p className='user-profile-div-text' onClick={onChangePasswordClick}>
              {translate('user-profile.second-table.title')}
            </p>
          </div>
          <div className='user-profile-logout-div'>
            <SignOutIcon className='user-profile-popover-icon' />
            <p className='user-profile-div-text' onClick={onLogOutClick}>
              {translate('menu.logout')}
            </p>
          </div>
        </div>
      }
      trigger='click'
    >
      <AppButton className='user-profile-round-button' variant='secondary' shape='round' size='lg' onClick={onClick}>
        {validActiveUser ? (
          <AppBadge color={badgeColor}>
            <AppAvatar
              className='user-profile-avatar'
              src={photoUrl || 'https://instaleap.s3.amazonaws.com/user-placeholder.png'}
            />
          </AppBadge>
        ) : (
          <AppAvatar
            className='user-profile-avatar'
            src={photoUrl || 'https://instaleap.s3.amazonaws.com/user-placeholder.png'}
          />
        )}
        <b> {firstName} </b>
        <CaretDownIcon />
      </AppButton>
    </AppPopover>
  )
}
